export const fetchNews = async (action, data) => {
  const response = await fetch(action, {
    method: "POST",
    body: data
  });
  if (response.status !== 200) {
    return [response, null];
  }
  const payload = await response.json();
  const {demand, news, settings} = payload;
  const newsRecords = news.map((rawRecord) => ({
    ...rawRecord,
    startDate: new Date(rawRecord.startDate),
    endDate: rawRecord.endDate ? new Date(rawRecord.endDate) : null
  }));
  return [response, {demand, news: newsRecords, settings}];
};
